import type { FC } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import DatePicker from '../../../components/global/DatePicker';

const FunnelFilter: FC<{ onSubmit: Function, onDownload?: Function, changeFilter: any, formFilter: any, data: any }> = ({ onSubmit, onDownload, changeFilter, formFilter, data }) => (
  <>
    <Grid container spacing={2}>
      <Grid item xl={2} md={2} xs={6}>
        <DatePicker
          value={formFilter.startDate}
          label="Desde:"
          name="startDate"
          onChange={changeFilter}
        />
      </Grid>
      <Grid item xl={2} md={2} xs={6}>
        <DatePicker
          value={formFilter.endDate}
          label="Hasta:"
          name="endDate"
          onChange={changeFilter}
        />
      </Grid>
      <Grid item xl={3} md={3} xs={6} style={{ display: 'none' }}>
        <TextField
          label="Convenio:"
          name="convenio"
          value={formFilter.convenio}
          fullWidth
          select
          size="small"
          SelectProps={{ native: true }}
          onChange={(e) => {
            changeFilter(e.target.name, e.target.value);
          }}
        >
          {data.convenio.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </TextField>
      </Grid>
      <Grid item xl={3} md={3} xs={6} style={{ display: 'none' }}>
        <TextField
          label="Canal de Venta:"
          name="channel"
          value={formFilter.channel}
          fullWidth
          select
          size="small"
          SelectProps={{ native: true }}
          onChange={(e) => {
            changeFilter(e.target.name, e.target.value);
          }}
        >
          {data.channel.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </TextField>
      </Grid>
      <Grid item xl={3} md={3} xs={6} style={{ display: 'none' }}>
        <TextField
          label="Usuario:"
          name="user"
          value={formFilter.user}
          fullWidth
          select
          size="small"
          SelectProps={{ native: true }}
          onChange={(e) => {
            changeFilter(e.target.name, e.target.value);
          }}
        >
          {data.channel.map((m) => (
            <option key={m.id} value={m.id}>
              {m.name}
            </option>
          ))}
        </TextField>
      </Grid>
      <Grid item xl={2} md={2} xs={6}>
        <Button
          onClick={() => onSubmit()}
          value="Aceptar"
          title="Aceptar"
          color="primary"
          variant="contained"
          fullWidth
        >
          Consultar
        </Button>
      </Grid>
      <Grid item xl={2} md={2} xs={6} style={{ display: 'none' }}>
        <Button
          onClick={() => onDownload()}
          value="Aceptar"
          title="Aceptar"
          color="primary"
          variant="contained"
          fullWidth
        >
          Descargar
        </Button>
      </Grid>
    </Grid>
  </>
);

export default FunnelFilter;
